import { Country } from '../types/location';

export const phoneNumberRegex = /^\+?1?\d{9,15}$/;
export const emailRegex =
  /^(([^<>()[\].,;:\s@"]+(\.[^<>()[\].,;:\s@"]+)*)|(".+"))@(([^<>()[\].,;:\s@"]+\.)+[^<>()[\].,;:\s@"]{2,})$/i;
export const latitudeRegex = /^-?([0-8]?[0-9]|90)(\.[0-9]{1,10})$/;
export const longitudeRegex = /^-?([0-9]{1,2}|1[0-7][0-9]|180)(\.[0-9]{1,10})$/;
export const stripeStatementDescriptorRegex =
  /^(?=.*[a-zA-Z])[^<>\\'"*]{5,22}$/;
export const vatNumberRegex = /^[a-zA-Z0-9 ]{0,15}$/;
export const ukVatNumberRegex = /^\d{9}$|^\d{12}$/;
export const ausBusinessNumberRegex = /^\d{11}$/;
export const japanVatNumberRegex = /^T\d{13}$/;
export const postalCodeRegex: Record<string, RegExp> = {
  AC: /^[A-Z]{4}[0-9][A-Z]$/,
  AD: /^AD[0-9]{3}$/,
  AF: /^[0-9]{4}$/,
  AI: /^AI-2640$/,
  AL: /^[0-9]{4}$/,
  AM: /^[0-9]{4}$/,
  AR: /^([0-9]{4}|[A-Z][0-9]{4}[A-Z]{3})$/,
  AS: /^[0-9]{5}(-[0-9]{4}|-[0-9]{6})?$/,
  AT: /^[0-9]{4}$/,
  AU: /^[0-9]{4}$/,
  AX: /^[0-9]{5}$/,
  AZ: /^AZ[0-9]{4}$/,
  BA: /^[0-9]{5}$/,
  BB: /^BB[0-9]{5}$/,
  BD: /^[0-9]{4}$/,
  BE: /^[0-9]{4}$/,
  BG: /^[0-9]{4}$/,
  BH: /^[0-9]{3,4}$/,
  BL: /^[0-9]{5}$/,
  BM: /^[A-Z]{2}([0-9]{2}|[A-Z]{2})$/,
  BN: /^[A-Z]{2}[0-9]{4}$/,
  BO: /^[0-9]{4}$/,
  BR: /^[0-9]{5}(-[0-9]{3})?$/,
  BT: /^[0-9]{3}$/,
  BY: /^[0-9]{6}$/,
  CA: /^[A-Z][0-9][A-Z][0-9][A-Z][0-9]$/,
  CC: /^[0-9]{4}$/,
  CH: /^[0-9]{4}$/,
  CL: /^([0-9]{7}|[0-9]{3}-[0-9]{4})$/,
  CN: /^[0-9]{6}$/,
  CO: /^[0-9]{6}$/,
  CR: /^[0-9]{4,5}$/,
  CU: /^[0-9]{5}$/,
  CV: /^[0-9]{4}$/,
  CX: /^[0-9]{4}$/,
  CY: /^[0-9]{4}$/,
  CZ: /^[0-9]{5}$/,
  DE: /^[0-9]{5}$/,
  DK: /^[0-9]{4}$/,
  DO: /^[0-9]{5}$/,
  DZ: /^[0-9]{5}$/,
  EC: /^EC[0-9]{6}$/,
  EE: /^[0-9]{5}$/,
  EG: /^[0-9]{5}$/,
  ES: /^[0-9]{5}$/,
  ET: /^[0-9]{4}$/,
  FI: /^[0-9]{5}$/,
  FK: /^[A-Z]{4}[0-9][A-Z]{2}$/,
  FM: /^[0-9]{5}(-[0-9]{4})?$/,
  FO: /^[0-9]{3}$/,
  FR: /^[0-9]{5}$/,
  GA: /^[0-9]{2}.*[0-9]{2}$/,
  GB: /^[A-Z][A-Z0-9]{1,3}[0-9][A-Z]{2}$/,
  GE: /^[0-9]{4}$/,
  GF: /^[0-9]{5}$/,
  GG: /^([A-Z]{2}[0-9]{2,3}[A-Z]{2})$/,
  GI: /^GX111AA$/,
  GL: /^[0-9]{4}$/,
  GP: /^[0-9]{5}$/,
  GR: /^[0-9]{5}$/,
  GS: /^SIQQ1ZZ$/,
  GT: /^[0-9]{5}$/,
  GU: /^[0-9]{5}$/,
  GW: /^[0-9]{4}$/,
  HM: /^[0-9]{4}$/,
  HN: /^[0-9]{5}$/,
  HR: /^[0-9]{5}$/,
  HT: /^[0-9]{4}$/,
  HU: /^[0-9]{4}$/,
  ID: /^[0-9]{5}$/,
  IL: /^([0-9]{5}|[0-9]{7})$/,
  IM: /^IM[0-9]{2,3}[A-Z]{2}$/,
  IN: /^[0-9]{6}$/,
  IO: /^[A-Z]{4}[0-9][A-Z]{2}$/,
  IQ: /^[0-9]{5}$/,
  IR: /^[0-9]{5}-[0-9]{5}$/,
  IS: /^[0-9]{3}$/,
  IT: /^[0-9]{5}$/,
  JE: /^JE[0-9]{2}[A-Z]{2}$/,
  JM: /^JM[A-Z]{3}[0-9]{2}$/,
  JO: /^[0-9]{5}$/,
  JP: /^[0-9]{3}-?[0-9]{4}$/,
  KE: /^[0-9]{5}$/,
  KG: /^[0-9]{6}$/,
  KH: /^[0-9]{5}$/,
  KR: /^[0-9]{5}$/,
  KY: /^KY[0-9]-[0-9]{4}$/,
  KZ: /^[0-9]{6}$/,
  LA: /^[0-9]{5}$/,
  LB: /^[0-9]{8}$/,
  LI: /^[0-9]{4}$/,
  LK: /^[0-9]{5}$/,
  LR: /^[0-9]{4}$/,
  LS: /^[0-9]{3}$/,
  LT: /^(LT-)?[0-9]{5}$/,
  LU: /^[0-9]{4}$/,
  LV: /^LV-[0-9]{4}$/,
  LY: /^[0-9]{5}$/,
  MA: /^[0-9]{5}$/,
  MC: /^980[0-9]{2}$/,
  MD: /^MD-?[0-9]{4}$/,
  ME: /^[0-9]{5}$/,
  MF: /^[0-9]{5}$/,
  MG: /^[0-9]{3}$/,
  MH: /^[0-9]{5}$/,
  MK: /^[0-9]{4}$/,
  MM: /^[0-9]{5}$/,
  MN: /^[0-9]{5}$/,
  MP: /^[0-9]{5}$/,
  MQ: /^[0-9]{5}$/,
  MT: /^[A-Z]{3}[0-9]{4}$/,
  MV: /^[0-9]{4,5}$/,
  MX: /^[0-9]{5}$/,
  MY: /^[0-9]{5}$/,
  MZ: /^[0-9]{4}$/,
  NA: /^[0-9]{5}$/,
  NC: /^[0-9]{5}$/,
  NE: /^[0-9]{4}$/,
  NF: /^[0-9]{4}$/,
  NG: /^[0-9]{6}$/,
  NI: /^[0-9]{5}$/,
  NL: /^[0-9]{4}[A-Z]{2}$/,
  NO: /^[0-9]{4}$/,
  NP: /^[0-9]{5}$/,
  NZ: /^[0-9]{4}$/,
  OM: /^[0-9]{3}$/,
  PA: /^[0-9]{6}$/,
  PE: /^[0-9]{5}$/,
  PF: /^[0-9]{5}$/,
  PG: /^[0-9]{3}$/,
  PH: /^[0-9]{4}$/,
  PK: /^[0-9]{5}$/,
  PL: /^[0-9]{2}-?[0-9]{3}$/,
  PM: /^[0-9]{5}$/,
  PN: /^[A-Z]{4}[0-9][A-Z]{2}$/,
  PR: /^[0-9]{5}$/,
  PT: /^[0-9]{4}(-?[0-9]{3})?$/,
  PW: /^[0-9]{5}$/,
  PY: /^[0-9]{4}$/,
  RE: /^[0-9]{5}$/,
  RO: /^[0-9]{6}$/,
  RS: /^[0-9]{5}$/,
  RU: /^[0-9]{6}$/,
  SA: /^[0-9]{5}$/,
  SD: /^[0-9]{5}$/,
  SE: /^[0-9]{5}$/,
  SG: /^([0-9]{2}|[0-9]{4}|[0-9]{6})$/,
  SH: /^(STHL1ZZ|TDCU1ZZ)$/,
  SI: /^(SI-)?[0-9]{4}$/,
  SK: /^[0-9]{5}$/,
  SM: /^[0-9]{5}$/,
  SN: /^[0-9]{5}$/,
  SV: /^01101$/,
  SZ: /^[A-Z][0-9]{3}$/,
  TC: /^TKCA1ZZ$/,
  TD: /^[0-9]{5}$/,
  TH: /^[0-9]{5}$/,
  TJ: /^[0-9]{6}$/,
  TM: /^[0-9]{6}$/,
  TN: /^[0-9]{4}$/,
  TR: /^[0-9]{5}$/,
  TT: /^[0-9]{6}$/,
  TW: /^([0-9]{3}|[0-9]{5})$/,
  UA: /^[0-9]{5}$/,
  US: /^[0-9]{5}(-[0-9]{4}|-[0-9]{6})?$/,
  UY: /^[0-9]{5}$/,
  UZ: /^[0-9]{6}$/,
  VA: /^00120$/,
  VC: /^VC[0-9]{4}$/,
  VE: /^[0-9]{4}[A-Z]?$/,
  VG: /^VG[0-9]{4}$/,
  VI: /^[0-9]{5}$/,
  VN: /^[0-9]{6}$/,
  WF: /^[0-9]{5}$/,
  XK: /^[0-9]{5}$/,
  YT: /^[0-9]{5}$/,
  ZA: /^[0-9]{4}$/,
  ZM: /^[0-9]{5}$/,
};

export const validateABN = (abn: string) => {
  const cleanedAbn = abn.replace(/\s+/g, '');

  // Check if the cleaned ABN matches the regex
  if (!ausBusinessNumberRegex.test(cleanedAbn)) {
    return false;
  }

  // Convert the string to an array of digits
  const digits = cleanedAbn.split('').map(Number);

  // Subtract 1 from the first digit
  digits[0] -= 1;

  // Define the weighting factors
  const weights = [10, 1, 3, 5, 7, 9, 11, 13, 15, 17, 19];

  // Calculate the sum of the products of the digits and their weights
  const sum = digits.reduce(
    (total, digit, index) => total + digit * weights[index],
    0,
  );

  // Check if the sum is divisible by 89
  return sum % 89 === 0;
};

export const validateVAT = (vatNumber: string): boolean => {
  // Remove all whitespace and possible "GB" prefix
  const cleanedVat = vatNumber.replace(/\s+/g, '').replace(/^GB/, '');

  // Check if the VAT number is 9 or 12 digits and contains only numbers

  if (!ukVatNumberRegex.test(cleanedVat)) {
    return false;
  }

  return true;
};

export const validateJapanVAT = (vatNumber: string): boolean => {
  // Remove all whitespace
  const cleanedVat = vatNumber.replace(/\s+/g, '');

  // Check if the ID starts with 'T' and is followed by 13 digits
  return japanVatNumberRegex.test(cleanedVat);
};
export const validatePostalCode = (country: Country, postalCode: string) => {
  const postalCodeFormatted =
    country === Country['United Kingdom'] || country === Country['Canada']
      ? postalCode.replace(' ', '')
      : postalCode;

  const isValidZipCode = postalCodeRegex?.[country].test(postalCodeFormatted);

  return isValidZipCode;
};

export const initialValueGateGeoCheckInByDistance = (
  locationGateGeoCheck: string,
  siteGateGeoCheck: boolean,
) => {
  if (locationGateGeoCheck === 'inherit_from_tenant') {
    return siteGateGeoCheck;
  } else {
    if (locationGateGeoCheck === 'enable_distance_gating') return true;
    else return false;
  }
};

export const editValueGateGeoCheckInByDistance = (
  locationGateGeoCheck: string,
  isChanged: boolean,
  enabled: boolean,
) => {
  if (locationGateGeoCheck === 'inherit_from_tenant' && !isChanged) {
    return 'inherit_from_tenant';
  } else {
    if (enabled) {
      return 'enable_distance_gating';
    } else {
      return 'disable_distance_gating';
    }
  }
};

export const formatNumberPrice = (input?: string | number | null) => {
  if (!input && input !== 0) return;

  const inputString = input?.toString();

  const numberValue = Number.parseFloat(inputString);
  if (!isNaN(numberValue)) {
    // Format the number with 2 decimal places and "." as separator
    return numberValue.toFixed(2);
  }
};

export const formatNumberPercentage = (input?: string) => {
  if (!input) return;

  const numberValue = Number.parseFloat(input);
  if (!isNaN(numberValue)) {
    // Format the number with 2 decimal places and "." as separator

    return numberValue.toFixed(3);
  }
};
